import { ovalModeActive, tvModeActive } from '@classes/app_url_params'
import type { ThreeDScene } from '@constants/types'

import type {
  UpdateThreeDAction
} from '../actions/threeD'
import {
  UPDATE_AUTO_ROTATE,
  UPDATE_BUTTONS_CONFIG,
  UPDATE_CALLOUTS_VISIBILITY,
  UPDATE_EXPLODED_MODE,
  UPDATE_RESET_CAMERA
} from '../actions/threeD'

export const initialThreeDState: ThreeDScene = {
  autoRotate: ovalModeActive() || tvModeActive(),
  explodedMode: false,
  calloutsVisible: true,
  buttonsConfig: {
    autoRotate: {
      enabled: false
    },
    exploded: {
      enabled: false
    },
    callouts: {
      enabled: false
    },
    resetCamera: {
      enabled: false
    }
  }
}

const threeDReducer = (state = initialThreeDState, action: UpdateThreeDAction) => {
  switch (action.type) {
    case UPDATE_AUTO_ROTATE: return { ...state, autoRotate: action.payload }
    case UPDATE_CALLOUTS_VISIBILITY: return { ...state, calloutsVisible: action.payload }
    case UPDATE_EXPLODED_MODE: return { ...state, explodedMode: action.payload }
    case UPDATE_RESET_CAMERA: return { ...state, resetCamera: action.payload }
    case UPDATE_BUTTONS_CONFIG: return { ...state, buttonsConfig: action.payload }
    default: return state
  }
}

export default threeDReducer
